import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { useMediaQuery, Typography, makeStyles } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import SplitButtons, { SplitButtonProps } from '../common/Buttons/SplitButtons';
import { String_System_Offline, String_CheckOut_ViewMenuButton, String_SystemOffline_Retry } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import LogoImage from '../../images/logo_footer.png'
import { UserState, UserStateContext } from '../../providers/UserStateContextProvider';

const useStyles = makeStyles({
    details: {
        position: 'absolute',
        top: (ElementDimensions.margin40 + ElementDimensions.appBarHeight) + 'px',
        bottom: ElementDimensions.footerBarHeightWithLogo + 'px',
        left: 0,
        right: 0,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    detailsLandscape: {
        position: 'absolute',
        top: (ElementDimensions.margin20) + 'px',
        bottom: ElementDimensions.footerBarHeightLandscape + 'px',
        left: 'calc(100vw *.3)',
        width: 'calc(100vw *.7)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    footerButtons: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        height: ElementDimensions.footerBarHeightWithLogo + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: '100%',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    footerButtonsLandscape: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 'calc(100vw *.3)',
        height: ElementDimensions.footerBarHeightLandscape + 'px',
        padding: ElementDimensions.padding10 + 'px ' + '0px ' + ElementDimensions.padding10 + 'px 0px',
        width: 'calc(100vw * .7)',
        borderTop: '2px solid ' + themePrimary.palette.grey[200],
        backgroundColor: themePrimary.palette.primary.contrastText,
    },
    instructionContainer: {
        textAlign: 'center',
        margin: '0px ' + ElementDimensions.margin10 + 'px ' + ElementDimensions.margin30 + 'px ' + ElementDimensions.margin10 + 'px',
    },
    instructionText: {
      marginBottom: ElementDimensions.margin20 + 'px',
    },
    logoContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        textAlign: 'center',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    root: {
        height: '100%',
    },
    rootLandscape: {
        height: '100%',
    },
});

const SystemOffline = () => {
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleLeftButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (checkOutState.state.menuUrl !== null) {
            window.open(checkOutState.state.menuUrl, "_blank");
        }
    }

    const handleRightButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        if (checkOutState.state.checkInUrl !== null) {
            window.location.href = checkOutState.state.checkInUrl;
        }
    }

    const splitButtonProps: SplitButtonProps = {
        leftLabel: String_CheckOut_ViewMenuButton.find(s => s.key === userState.state.locale)!!.value,
        rightLabel: String_SystemOffline_Retry.find(s => s.key === userState.state.locale)!!.value,
        leftDisabled: false,
        rightDisabled: false,
        showIcons: false,
        useForwardIcon: false,
        useBackIcon: false,
        onLeftClickHandler: handleLeftButtonClick,
        onRightClickHandler: handleRightButtonClick,
    }

    return (
        <div className={isPortrait === true ? classes.root : classes.rootLandscape}>

                <div className={isPortrait === true ? classes.details : classes.detailsLandscape}>
                    <div>
                        <div className={classes.instructionContainer}>
                            <Typography variant="h4" className={classes.instructionText}>
                                {String_System_Offline.find(s => s.key === userState.state.locale)!!.value}
                            </Typography>
                        </div>
                    </div>
                </div>

                <div className={isPortrait ? classes.footerButtons : classes.footerButtonsLandscape}>

                    <SplitButtons
                        leftLabel={splitButtonProps.leftLabel}
                        rightLabel={splitButtonProps.rightLabel}
                        leftDisabled={splitButtonProps.leftDisabled}
                        rightDisabled={splitButtonProps.rightDisabled}
                        showIcons={splitButtonProps.showIcons}
                        useForwardIcon={splitButtonProps.useForwardIcon}
                        useBackIcon={splitButtonProps.useBackIcon}
                        onLeftClickHandler={splitButtonProps.onLeftClickHandler}
                        onRightClickHandler={splitButtonProps.onRightClickHandler} />

                    {isPortrait &&
                        <div className={classes.logoContainer}>
                            <img src={LogoImage}></img>
                        </div>
                    }

                </div>

         </div>
    );
};

export default SystemOffline;